import React from 'react';
import NavButton from '../../components/NavMenu/NavButton';
import NavMenu from '../../components/NavMenu/NavMenu';
import MapHint from '../../components/MapHint/MapHint';
import { RoutePlannerContext } from '../../context/RoutePlannerContext';

const Main = () => {
    const [openNav, setOpenNav] = React.useState(false);
    const [routePlannerOpen, setRoutePlannerOpen] = React.useState(false);
    const [hintVisible, setHintVisible] = React.useState(true);

    const routePlannerValue = {
        isOpen: routePlannerOpen,
        open: () => setRoutePlannerOpen(true),
        close: () => setRoutePlannerOpen(false),
    };

    React.useEffect(() => {
        if (routePlannerOpen || openNav) {
            setHintVisible(false);
        }
    }, [routePlannerOpen, openNav]);

    return (
        <RoutePlannerContext.Provider value={routePlannerValue}>
            <div className="Main">
                <header>
                    <NavButton open={openNav} setOpenNav={setOpenNav} />
                    <NavMenu open={openNav} setOpenNav={setOpenNav} />
                </header>
                <MapHint visible={hintVisible} onDismiss={() => setHintVisible(false)} />
            </div>
        </RoutePlannerContext.Provider>
    );
}
export default Main;
